function enviromentGlobal() {
  const uri = window.location.toString()
  const enviroment = uri.split(".")
  switch (enviroment[1]) {
    case "qa":
      return "QA"
    case "uat":
      return "UAT"
    case "webcgi":
      return "DEV"
    case "errepar":
      return "PROD"
    default:
      return "UAT"
  }
}

class ParserClass {
  constructor() {
    if (ParserClass.instance) {
      return ParserClass.instance
    }
    Object.freeze(this)
    ParserClass.instance = this
  }

  getEnvironment() {
    return enviromentGlobal()
  }

  getDomain() {
    const uri = window.location.toString()
    const enviroment = uri.split("/")
    if (enviroment[2].includes("localhost")) return "localhost"
    return enviroment[2] || ""
  }
}
const parser = new ParserClass()

export default parser
